/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
import HeadTittle from "../../../components/HeadTittle";
import DivContainerBody from "../../../components/DivContainerBody";
import React from "react";
import CustomAccordion from "../../../components/Accordion/CustomAccordion";
import {CustomAntSwitch} from "../../../components/CustomAntSwitch";
import {Box} from "@mui/material";
import ButtonAction from "../../../components/buttons/ButtonAction";
import {EditIcon} from "../../../components/buttons/IconButtons";
import SettingConfigApp from "./Functionality/SettingConfigApp";
import {permissionObj} from "../../../Helpers/permission";

const SettingConfig = () => {
    const { t, DEV, permission, disabled, settingConfig, emptyFields, handleUpdate, handleChange} = SettingConfigApp();

    return <>
        <HeadTittle name={"system_config"}>
            {(DEV || permission.includes(permissionObj.WEB_SYSTEM_CONFIG_UPDATE)) &&
                <ButtonAction
                    id={"btn_sp_update"}
                    name='update'
                    className={`btn-icon-edit`}
                    Icon={EditIcon}
                    onClick={handleUpdate}
                />
            }
        </HeadTittle>
        <DivContainerBody>
            <div className={"row mt-4"}>
                <div className={"col-12"}>
                    <CustomAccordion
                        title={t("security")}
                        currentKey={0}
                        header={ <h3>{t("security")}</h3>}>
                        <Box className="col-12">
                            <CustomAntSwitch id={"sch_sp_otp_verification"}
                                             title={t('enable_otp_verification').toUpperCase()}
                                             name={"enableOtp"}
                                             checked={settingConfig?.enableOtp}
                                             onChange={(e) => handleChange(e)}
                                             disabled={disabled}
                                             emptyFields={emptyFields}
                                             transLeft={"NO"}
                                             transRight={"YES"}
                            />
                        </Box>

                    </CustomAccordion>
                </div>
                <div className={"col-12"}>
                    <CustomAccordion
                        title={t("application")}
                        currentKey={0}
                        header={ <h3>{t("application")}</h3>}>
                        <Box className="col-12">
                            <CustomAntSwitch id={"sch_sp_mobile_app"}
                                             title={t('mobile_app').toUpperCase()}
                                             name={"hasApplication"}
                                             checked={settingConfig?.hasApplication}
                                             onChange={(e) => handleChange(e)}
                                             disabled={disabled}
                                             emptyFields={emptyFields}
                                             transLeft={"NO"}
                                             transRight={"YES"}
                            />
                        </Box>

                    </CustomAccordion>
                </div>
            </div>
        </DivContainerBody>
    </>

}

export default SettingConfig;
